import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
  'filteredList': [],
};

export const warehouses = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_WAREHOUSES_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WAREHOUSES_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
      'filteredList': action.response.data,
    }),
    [ActionTypes.FETCHED_WAREHOUSES_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
      'filteredList': [],
    }),
  })(state, action);
};
